<template>
  <div style="height: 100%;">
    <div>
      <Header />
      <div class="main-wrapper plolicy-top-box width1200 service-box">
            <div class="search-box">
                <!-- <select>
                  <option>北京</option>
                  <option>上海</option>
                  <option>深圳</option>
                </select> -->
                <div class="search-input-box">
                  <input type="type" placeholder="请输入搜索内容" name="" v-model="searchkey">
                  <button @click="cliSearch">搜索</button>
                </div>
            </div>

            <div class="policy-main">
                <div class="policy-top-tab">
                    <!-- tab nav -->
                    <ViewTabListOrg />
                    <!-- tab nav -->
                    
                    <!-- 筛查条件-移动端 -->

                    <!-- 筛查条件-移动端 -->
                    <SearchCondition @activeItem="onActiveItem" @onselected="onConditionSelected" :items="initSearchCondition" :selectedKeys="selectedKeys"/>
                </div>

                <div class="main-container">
                  <!-- 筛查条件pc -->
                    <div class="screening-box  main-container-left">
                        <div class="screen-items">
                          <div class="right-text">
                            <div style="width: 150px;">
                              <p>服务类型 ：</p>
                            </div>
                            <div>
                              <a href="javascript:;" :class="serviceType==index?'active':''" @click="selectService(index)" v-for="(item,index) in services">{{item}}</a>
                              <!-- <span class="more-btn">更多<img src="../assets/main/bottom-arrow.png" alt=""></span> -->
                            </div>
                          </div>
                        </div>
                        <div class="screen-items">
                          
                          <div class="right-text height-auto">
                            <div style="width: 150px;">
                              <p>专业领域 ：</p>
                            </div>
                            <div>
                              <a href="javascript:;" :class="seltpys==index?'active':''" v-for="(item,index) in projecttypes" @click="selectprojecttypes(index)">{{item}}</a>
                              <!-- <span class="more-btn">全部区域<img src="../assets/main/bottom-arrow.png" alt=""></span> -->
                            </div>
                          </div>
                        </div>
                        <div class="screen-items">
                          
                          <div class="right-text height-auto">
                            <div style="width: 150px;">
                              <p>细分领域 ：</p>
                            </div>
                            <div>
                              <a href="javascript:;" :class="seldtypes==index?'active':''" v-for="(item,index) in projectDetailTypes[seltpys]" @click="selectprojectDetailTypes(index)">{{item}}</a>
                              <!-- <span class="more-btn">全部区域<img src="../assets/main/bottom-arrow.png" alt=""></span> -->
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- 筛查条件pc -->
                    <div class="main-container-right main-container-right-pc">
                      <!-- 政策列表 -->
                      <div class="policy-list policy-list-service">
                          <ul v-if="!hidelist">
                            <li class="policy-li" v-for="(item,index) in resultlist" :key="index" @click="openDetail(item.sid)">
                              <div class="left-txt">
                                    <div class="img1">
                                      <img  :src="item.img">
                                    </div>
                                    <div class="service-title">
                                      <h3>{{item.service_name}}</h3>
                                      <!-- <p class="pp1">{{item.service_description}}</p> -->
                                      <p class="pp2">发布时间:{{item.create_time}}</p>
                                      <div class="btn-box">
                                          <a href="javascript:;">{{item.service_category}}</a>
                                          <a href="javascript:;">{{item.industry_category}}</a>
                                      </div>
                                    </div>
                              </div>
                              <div class="talent-plan">
                                  <a href="javascript:;">{{item.province}}</a>
                              </div>
                            </li>

                          </ul>
                      </div>
                      <div class="paging-box">
                        <el-pagination layout="prev, pager, next" :page-size="limit" :total="count" @current-change="pagechange"></el-pagination>
                      </div>
                    </div>
                </div>

            </div>

      </div>
      <Footer :isLogin="true" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ViewTabListOrg from '@/components/ViewTabListOrg.vue';
import config from '@/config/index';
import {
    Pagination
  } from 'element-ui';
import{
  searchorg,
  searchproduct,
  searchservice,
} from '@/api/searchOPP.js'
import SearchCondition from '@/components/SearchCondition.vue';
  import {ServiceSearchCondition} from '@/const/ServiceSearchCondition.js'
  import SearchConditionMixin from '@/mixins/SearchCondition.mixin.js'
export default {
  mixins: [SearchConditionMixin],
    name: 'Service',
    components: {
        Header,
        Footer,
        ViewTabListOrg,
        [Pagination.name]: Pagination,
        SearchCondition,
    },
    watch: {
        $route(to, from) {}
    },
    data() {
        return {
          hidelist:false,
          initSearchCondition: ServiceSearchCondition,
          resultlist:[],
          page: 1,
          limit: 10,
          count: 0,
          searchkey: '',
          servicecategory:'',
          industrycategory:'',

          ptypes: ['全部', '服务型', '产品型'],
          selptype: 0,

          services: ['全部', '咨询规划', '专业设计', '工程建设', '人力外包', '监理审计', '创新场景','金融服务'],
          serviceType: 0,

          projecttypes: ['全部','智慧应用', '数据智能', '生态系统', '可信安全', '新型网络', '智慧专区', '数字上云', '金融服务'],
          seltpys: 0,
          projectDetailTypes: [
            ['全部'],
            ['智慧政务应用', '智慧城市应用', '智慧民生应用', '智慧产业应用', '传统基础设施赋能', '中小企业赋能'],
            ['数据中心', '云边端', '大数据平台', '人工智能', '区块链服务平台', '数据交易'],
            ['产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台'],
            ['基础安全能力', '行业应用安全', '新型安全服务平台'],
            ['5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网'],
            ['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务'],
            ['云计算', '域名', '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商'],
            ['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
          ],
          seldtypes: 0
        }
    },
    mounted() {
      if(this.$route.query.keyword){
        this.searchkey = this.$route.query.keyword
      }
      this.querySearchservice()
    },
    methods: {
      cliSearch(){
        this.querySearchservice()
      },
      selectprojecttypes(index){
        this.seltpys=index
        if (index == 0) {
          this.industrycategory =''
          this.seldtypes=0
          this.querySearchservice()
        }else{
          this.seldtypes=-1
        }
      },
      selectprojectDetailTypes(index){
        this.seldtypes = index
        this.industrycategory = this.projectDetailTypes[this.seltpys][index]
        this.querySearchservice()
      },
      selectService(index) {
        this.serviceType = index
        if (index == 0) {
          this.servicecategory = ''
        } else {
          this.servicecategory = this.services[index]
        }
        console.log(this.servicecategory)
        this.querySearchservice()
      },
      pagechange(page) {
        this.page = page
        this.querySearchservice()
      },
      querySearchservice(){
        const servicecategory = this.servicecategory
        const industrycategory = this.industrycategory
        const page = this.page
        const limit = this.limit
        const searchkey = this.searchkey
        this.$http.get(searchservice(),{searchkey,servicecategory,industrycategory,page,limit}).then(res => {
            console.log(res);
            if (res.code === 1) {
                this.resultlist = []
                this.count = res.data.count
                var list = res.data.list
                var item;
                for(var i=0;i<list.length;i++){
                  item = list[i]
                  var img = JSON.parse(item.img)[0]
                  item.img = `${config.HOST_IMG}${img}`
                   this.resultlist.push(item)
                }
            } else {
                this.$message.warning(res.msg);
            }
        });
      },
      openDetail(sid){
        this.$router.push("/detail/service?sid="+sid)
      },
      toogleListShow(hide){
        this.hidelist = hide
        if(hide==false){
          console.log("this.selectedKeys-->",this.selectedKeys)

          this.selectedKeys.forEach(item=>{
            if(item.boxKey==="服务类别"){
              if (item.item.index === 0) {
                this.servicecategory = ''
              } else {
                this.servicecategory = item.key
              }
            }else{
              if (item.key === 'item-0-专业领域-全部') {
                this.industrycategory =''
              }else{
                this.industrycategory = item.key
              }
            }
          })
          this.querySearchservice()

        }
      }
    }
}
</script>

<style scoped>
  @import url(./Policy.css);
  @import url(./service.css);
  .paging-box {
    text-align: center;
    /* margin: 30px 0 30px 140px; */
    overflow: hidden;
  }
</style>
